<app-help-cta
  [originPage]="'Billing'"
  [hasInvoice]="selectedInvoice ? true : false"
></app-help-cta>

<div
  class="relative h-screen w-[calc(50vw-15px)] overflow-hidden rounded-tl-xl bg-white pl-4 pt-4 shadow-[-2px_5px_15px_rgba(0,0,0,0.1)] transition-all duration-300 ease-in-out"
>
  @if (isInvoicesLoading || pdfLoading) {
    <div class="flex h-full w-full items-center justify-center">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
  } @else {
    @if (selectedInvoice) {
      <div class="mb-4 border-b border-gray-500 pb-4">
        <div class="flex items-center justify-between">
          <h2 class="text-base font-normal">
            Posted on
            {{
              selectedInvoice.ContentDocument.Title.slice(0, 10)
                | date: 'longDate'
            }}
          </h2>
          <button
            class="mr-5 flex h-9 w-9 items-center justify-center rounded-full transition-colors duration-200 hover:bg-blue-100 focus:outline-none"
            (click)="onDownload(selectedInvoice)"
          >
            <mat-icon svgIcon="pdf-file" class="text-blue-500"></mat-icon>
          </button>
        </div>
      </div>

      <div
        class="relative mt-0 h-[calc(100vh-322px)] w-full overflow-hidden pt-2.5"
      >
        @if (pdfUrl && canEmbedPdf) {
          <div class="h-full w-full overflow-auto">
            <pdf-viewer
              [src]="pdfUrl"
              [(page)]="page"
              [show-all]="true"
              [show-borders]="false"
              [original-size]="false"
              [autoresize]="true"
              [render-text]="true"
              (error)="onError()"
              (after-load-complete)="afterLoadComplete($event)"
              class="block h-full w-full"
            ></pdf-viewer>
          </div>
        }

        @if (pdfLoading) {
          <div class="flex h-full w-full items-center justify-center">
            <mat-spinner [diameter]="40"></mat-spinner>
          </div>
        }
      </div>

      @if (!canEmbedPdf && !pdfLoading) {
        <div class="mt-6 p-4 text-center text-gray-600">
          You don't have a PDF plugin, but you can
          <button
            class="cursor-pointer border-none bg-transparent p-0 text-base text-blue-600 underline transition-colors hover:text-blue-800"
            (click)="onDownload(selectedInvoice)"
          >
            download the PDF
          </button>
        </div>
      }
    } @else {
      <div class="h-screen w-[calc(50vw-15px)] rounded-l-2xl pl-4 pt-4">
        <div class="mb-6 border-b border-gray-500 pb-6">
          <h2 class="text-base font-normal">- - -</h2>
        </div>
        @if (!isInvoicesLoading) {
          <p class="py-6 text-center">
            No invoices have posted to this account yet.
          </p>
        }
      </div>
    }
  }
</div>
